"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownSelect = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _DropdownSelect = require("./DropdownSelect.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DropdownSelect = exports.DropdownSelect = function DropdownSelect(props) {
  var onClick = props.onClick,
    options = props.options,
    type = props.type,
    defaultText = props.defaultText,
    srMessage = props.srMessage,
    id = props.id,
    defaultChecked = props.defaultChecked,
    _props$position = props.position,
    position = _props$position === void 0 ? 'left' : _props$position,
    onChecked = props.onChecked;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultChecked),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    checked = _useState4[0],
    setChecked = _useState4[1];
  var dropdownRef = (0, _react.useRef)(null);
  var handleClick = function handleClick() {
    setShow(!show);
  };
  var onInputClick = function onInputClick(event, optionId) {
    onClick === null || onClick === void 0 || onClick(event);
    setChecked(optionId);
    onChecked === null || onChecked === void 0 || onChecked(optionId);
  };
  (0, _react.useEffect)(function () {
    setChecked(defaultChecked);
  }, [defaultChecked]);
  (0, _react.useEffect)(function () {
    var handleClickOut = function handleClickOut(event) {
      if (!dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener('mousedown', handleClickOut);
    return function () {
      document.removeEventListener('mousedown', handleClickOut);
    };
  }, [dropdownRef]);
  var checkedOption = options.find(function (option) {
    return option.checked || option.id === checked;
  });
  if (!checkedOption) {
    checkedOption = options[0];
  }
  var buttonText = defaultText || checkedOption && checkedOption.label;
  return /*#__PURE__*/_react["default"].createElement(_DropdownSelect.DropdownWrapper, {
    ref: dropdownRef,
    id: id,
    type: type
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleClick
  }, buttonText, " ", /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faChevronDown
  })), /*#__PURE__*/_react["default"].createElement(_DropdownSelect.InputsWrapper, {
    $position: position,
    show: show
  }, /*#__PURE__*/_react["default"].createElement("legend", {
    className: "visually-hidden"
  }, srMessage), options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_DropdownSelect.InputGroup, {
      key: option.id
    }, /*#__PURE__*/_react["default"].createElement("input", {
      onClick: function onClick(event) {
        return onInputClick(event, option.id);
      },
      type: type,
      id: option.id,
      value: option.label,
      checked: option.id === checkedOption.id,
      name: option.name,
      readOnly: true
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: option.id,
      onClick: function onClick(event) {
        return onInputClick(event, option.id);
      }
    }, option.label));
  })));
};
DropdownSelect.propTypes = {
  onClick: _propTypes.func,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    label: _propTypes.string,
    checked: _propTypes.bool
  })).isRequired,
  type: (0, _propTypes.oneOf)(['checkbox', 'radio']),
  defaultText: _propTypes.string,
  srMessage: _propTypes.string,
  id: _propTypes.string,
  onChecked: _propTypes.func,
  defaultChecked: _propTypes.string
};